import { createFileRoute } from '@tanstack/react-router';
import { LicenseManagerPage } from 'features/license-manager/components/license-manager-page/license-manager';

export const Route = createFileRoute('/spaces/license-manager/_saasLayout/')({
  component: LicenseManagerPage,
});
